import { render, staticRenderFns } from "./ProducerSelect.vue?vue&type=template&id=19c0159f&scoped=true&"
import script from "./ProducerSelect.vue?vue&type=script&lang=js&"
export * from "./ProducerSelect.vue?vue&type=script&lang=js&"
import style0 from "./ProducerSelect.vue?vue&type=style&index=0&id=19c0159f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c0159f",
  null
  
)

export default component.exports